import React from "react";
import { Link } from "react-router-dom";
import logo from "../../images/logo_moodlift.png";
import { useSelector } from "react-redux";
import t from "../translate";

const NavBar = (props) => {

  const auth = useSelector(state => state.auth);
  /*
  <span className={(auth.user_id !== 0) ? 'loggedInAs' : 'hidden'} >
    {t("Ingelogd als: ")} {auth.name} ({auth.userType})
  </span>
  */

  function unsetStudentDetails() {
    if (typeof props.setDetailsVisible === "function") {
      props.setDetailsVisible(false);
    }
  }
  return (
    <div>
      {auth.userType != "student" ?
      <nav className="navbar navbar-expand-lg navbar-light">
        <Link to="/" className="brandLogo" onClick={unsetStudentDetails}>
          <img src={logo} className="logo"/>
          <span className="brandLogo__tagline">Education</span>
        </Link>
      </nav>
      :'' }
    </div>
  );
};

export default NavBar;
